var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{domProps:{"innerHTML":_vm._s(_vm.strings.ask_to_login)}}),_c('loginRegister',{attrs:{"actionAfterLogin":"emit_even","modelRegisterForm":"generate_password"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }